'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      navigator.serviceWorker
        .register('/api/sw', { scope: '/' })
        .then((reg) => {
          setInterval(() => reg.update(), 60 * 60 * 1000);
        })
        .catch((err) => console.error('SW registration failed:', err));
    }

    // When internet comes back, silently revalidate all SWR caches
    const handleOnline = () => {
      // SWR auto-revalidates on focus/reconnect, but trigger a revalidation
      // by dispatching a focus event (SWR listens to this by default)
      window.dispatchEvent(new Event('focus'));
    };

    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, []);

  return null;
}
